(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-range"] && !Shopify.designMode) return;
  try {
    
const selector = '[js-collection-range="collections"]';
let intervalId;

function initializeMarquee(selector) {
  const parent = document.querySelector(selector);

  if (!parent) return;

  const speed = Number(parent.style.getPropertyValue('--delay')) || 4000;

  const children = Array.from(parent.children);

  if (children.length === 0) return;

  let childIndex = 0;

  const setTranslateX = () => {
    const childWidth = children[childIndex].offsetWidth;
    const parentWidth = parent.offsetWidth;
    const childOffset = children[childIndex].offsetLeft;
    const translateXValue = (parentWidth / 2) - (childOffset + (childWidth / 2));

    parent.style.transform = `translateX(${translateXValue}px)`;

    children.forEach((child, index) => {
      if (index === childIndex) {
        child.classList.add('is-active');
      } else {
        child.classList.remove('is-active');
      }
    });

    childIndex = (childIndex + 1) % children.length;
  };

  intervalId = setInterval(setTranslateX, speed);
}

function destroyMarquee() {
  if (intervalId) clearInterval(intervalId);

  document.querySelector(selector).style.transform = 'none';
  const children = Array.from(document.querySelector(selector).children);

  children.forEach((child) => {
    child.classList.remove('is-active');
  });
}

const checkDeviceAndUpdateMarquee = () => {
  const isMobile = window.matchMedia('(max-width: 768px)').matches;

  if (isMobile && !intervalId) {
    initializeMarquee(selector);
  } else if (!isMobile && intervalId) {
    destroyMarquee();
  }
};

window.addEventListener('resize', checkDeviceAndUpdateMarquee);
window.addEventListener('DOMContentLoaded', checkDeviceAndUpdateMarquee);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-collections"] && !Shopify.designMode) return;
  try {
    
  if (window.innerWidth >= 768) {
    return
  }

  const wrapper = document.querySelector('[js-featured-collections="wrapper"]')
  const children = Array.from(wrapper.children)

  addActiveClass()
  wrapper.addEventListener('scrollend', () => {
    addActiveClass()
  })

  function addActiveClass() {
    children.forEach(child => {
      child.classList.remove('is-active')

      const rect = child.getBoundingClientRect()

      const isVisible = (
        rect.left >= 0 &&
        rect.right <= window.innerWidth
      )

      if (isVisible) {
        child.classList.add('is-active')
      }
    })
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["marquee-testimonials"] && !Shopify.designMode) return;
  try {
    
const selector = '[js-marquee-testimonials="marquee"]';
let intervalId;

function initializeMarquee(selector) {
  const parent = document.querySelector(selector);

  if (!parent) return;

  const speed = Number(parent.style.getPropertyValue('--marquee-delay')) || 4000;

  const children = Array.from(parent.querySelector('.marquee-testimonials__list').children);

  if (children.length === 0) return;

  let childIndex = 0;

  const setTranslateX = () => {
    const childWidth = children[childIndex].offsetWidth;
    const parentWidth = parent.offsetWidth;
    const childOffset = children[childIndex].offsetLeft;
    const translateXValue = (parentWidth / 2) - (childOffset + (childWidth / 2));

    parent.style.transform = `translateX(${translateXValue}px)`;

    children.forEach((child, index) => {
      if (index === childIndex) {
        child.classList.add('is-active');
      } else {
        child.classList.remove('is-active');
      }
    });

    childIndex = (childIndex + 1) % children.length;
  };

  setTranslateX()

  intervalId = setInterval(setTranslateX, speed);
}

function destroyMarquee() {
  if (intervalId) clearInterval(intervalId);

  document.querySelector(selector).style.transform = 'none';
  const children = Array.from(document.querySelector(selector).children);

  children.forEach((child) => {
    child.classList.remove('is-active');
  });
}

const checkDeviceAndUpdateMarquee = () => {
  const isMobile = window.matchMedia('(max-width: 834px)').matches;

  if (isMobile && !intervalId) {
    initializeMarquee(selector);
  } else if (!isMobile && intervalId) {
    destroyMarquee();
  }
};

window.addEventListener('resize', checkDeviceAndUpdateMarquee);
window.addEventListener('DOMContentLoaded', checkDeviceAndUpdateMarquee);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-grid-media"] && !Shopify.designMode) return;
  try {
    
  const tabs = document.querySelectorAll('.product-grid-media__products')
  const back = document.querySelector('[js-product-grid-media="back"]')
  const viewAll = document.querySelectorAll('[js-product-grid-media="view-all"]')

  viewAll.forEach((button) => {
    button.addEventListener('click', () => {
      const activeProducts = document
        .querySelector('.product-grid-media__products.active')
        .querySelectorAll('.product-grid-item')

      activeProducts.forEach(product => {
        product.style.display = 'block'
      })
    })
  })

  tabs.forEach((tab) => {
    tab.addEventListener('scroll', (event) => {
      const scrolledPercent = (event.target.scrollLeft / (event.target.scrollWidth - event.target.clientWidth)) * 100
      back.style.opacity = scrolledPercent / 100;
    })
  })

  back.addEventListener('click', () => {
    const activeTab = document.querySelector('.product-grid-media__products.active')

    activeTab.scrollTo(0, 0)
  })

  if (window.innerWidth < 768) {
    return
  }


  tabs.forEach((tab) => {
    let slider = tab
    let isDown = false
    let startX
    let scrollLeft

    slider.addEventListener('mousedown', (e) => {
      isDown = true
      startX = e.pageX - slider.offsetLeft
      scrollLeft = slider.scrollLeft
    })

    slider.addEventListener('mouseleave', () => {
      isDown = false
    })

    slider.addEventListener('mouseup', () => {
      isDown = false
    })

    slider.addEventListener('mousemove', (e) => {
      if(!isDown) {
        return
      }

      e.preventDefault()

      const x = e.pageX - slider.offsetLeft
      const walk = (x - startX) * 2

      slider.scrollLeft = scrollLeft - walk
    })
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["products-media-backdrop"] && !Shopify.designMode) return;
  try {
    
  const products = document.querySelector('.products-media-backdrop__products')
  const back = document.querySelector('[js-products-media-backdrop="back"]')

  products.addEventListener('scroll', (event) => {
    const scrolledPercent = (event.target.scrollLeft / (event.target.scrollWidth - event.target.clientWidth)) * 100
    back.style.opacity = scrolledPercent / 100;
  })

  back.addEventListener('click', () => {
    products.scrollTo(0, 0)
  })

  if (window.innerWidth < 768) {
    return
  }

  let isDown = false
  let startX
  let scrollLeft

  products.addEventListener('mousedown', (e) => {
    isDown = true
    startX = e.pageX - products.offsetLeft
    scrollLeft = products.scrollLeft
  })

  products.addEventListener('mouseleave', () => {
    isDown = false
  })

  products.addEventListener('mouseup', () => {
    isDown = false
  })

  products.addEventListener('mousemove', (e) => {
    if(!isDown) {
      return
    }

    e.preventDefault()

    const x = e.pageX - products.offsetLeft
    const walk = (x - startX) * 2

    products.scrollLeft = scrollLeft - walk
  })

  } catch(e) { console.error(e); }
})();
})();
